
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/prism-survival-analysis",
      function () {
        return require("private-next-pages/features/prism-survival-analysis.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/prism-survival-analysis"])
      });
    }
  